import { createContextManager, storeContextManager } from '@datadog/browser-core';
export function startGlobalContext(hooks, configuration) {
    const globalContextManager = buildGlobalContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, globalContextManager, 'rum', 2 /* CustomerDataType.GlobalContext */);
    }
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => ({
        type: eventType,
        context: globalContextManager.getContext(),
    }));
    return globalContextManager;
}
export function buildGlobalContextManager() {
    return createContextManager('global context');
}
//# sourceMappingURL=globalContext.js.map